import { render, staticRenderFns } from "./GrowersStatistics.vue?vue&type=template&id=0f414878&"
import script from "./GrowersStatistics.vue?vue&type=script&lang=js&"
export * from "./GrowersStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports